import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
const ForSaleTransactionSummary = (props) => {
    const listingText = `Last listed on ${props.listingDate} at ${props.listingPrice}`;
    if (!props.listingDate && !props.listingPrice) {
        return null;
    }
    return (
        <Typography
            sx={props.sx}
            title={listingText}
        >
            {listingText}
        </Typography>
    )
};

ForSaleTransactionSummary.propTypes = {
    listingDate: PropTypes.string,
    listingPrice: PropTypes.string,
    sx: PropTypes.object,
};
export default ForSaleTransactionSummary;